/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type AwardPayPromoQueryVariables = {
    mobile: string;
};
export type AwardPayPromoQueryResponse = {
    readonly wallet: {
        readonly user: {
            readonly elligibleToReceivePayPromo: boolean | null;
        } | null;
    } | null;
};
export type AwardPayPromoQuery = {
    readonly response: AwardPayPromoQueryResponse;
    readonly variables: AwardPayPromoQueryVariables;
};



/*
query AwardPayPromoQuery(
  $mobile: String!
) {
  wallet(mobile: $mobile) {
    user {
      elligibleToReceivePayPromo
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mobile"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "mobile",
    "variableName": "mobile"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "elligibleToReceivePayPromo",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AwardPayPromoQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Wallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AwardPayPromoQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Wallet",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "08d5cd088636481204d584233c244831",
    "id": null,
    "metadata": {},
    "name": "AwardPayPromoQuery",
    "operationKind": "query",
    "text": "query AwardPayPromoQuery(\n  $mobile: String!\n) {\n  wallet(mobile: $mobile) {\n    user {\n      elligibleToReceivePayPromo\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '018cc030eee6a6b79acdc5caf1a1cf19';
export default node;
